import { render, staticRenderFns } from "./MallDetail.vue?vue&type=template&id=4a21620a&scoped=true"
import script from "./MallDetail.vue?vue&type=script&lang=js"
export * from "./MallDetail.vue?vue&type=script&lang=js"
import style0 from "./MallDetail.vue?vue&type=style&index=0&id=4a21620a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a21620a",
  null
  
)

export default component.exports